import { Contact } from '../..';
import { apiUtils } from '../../api-utils';


export function getContacts(clientID: string, customerID: string): Promise<Contact[]> {
    return apiUtils.get(`/client/${clientID}/customer/${customerID}/contact`);
}

export function deleteContact(clientID: string, customerID: string, contactID: string): Promise<void> {
    return apiUtils.delete(`/client/${clientID}/customer/${customerID}/contact/${contactID}`);
}

export function addContact(clientID: string, customerID: string, contact: Omit<Contact, 'id'>): Promise<Contact> {
    return apiUtils.post(`/client/${clientID}/customer/${customerID}/contact`, contact);
}

export function editContact(clientID: string, customerID: string, contact: Contact): Promise<Contact> {
    return apiUtils.put(`/client/${clientID}/customer/${customerID}/contact/${contact.id}`, contact);
}
